import { datadogRum } from "./datadogRum";
import { getDatadogRumConfig } from "./config";

// Side-effect boundary: the only place that actually calls `datadogRum.init`.
// All decision/transform logic lives in the pure `config`/`scrubbing` modules.

/**
 * Initializes Datadog RUM if it is enabled and configured for this environment.
 * No-op otherwise. Safe to call unconditionally at app bootstrap.
 */
export const initDatadogRum = (): void => {
  const config = getDatadogRumConfig();

  if (!config) return;

  datadogRum.init(config);
};
